import { ApolloError, useReactiveVar } from "@apollo/client";
import { useGetLinkAndQrCodeMenuQuery } from "@me-team/host/main/menu/graphql/menu.hooks";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

interface UseQrMenuProps {
    branchId?: string | number;
    menuId?: string | number;
    menusListId?: string | number;
    onError?: (error: ApolloError) => void;
}

export const useLinkAndQrCodeMenu = ({ branchId, menuId, menusListId, onError }: UseQrMenuProps) => {
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const {
        data: linkAndQrCodeMenuData,
        loading: linkAndQrCodeMenuLoading,
        refetch: linkAndQrCodeMenuRefetch,
    } = useGetLinkAndQrCodeMenuQuery({
        skip: !currentCompanyId,
        variables: {
            companyId: Number(currentCompanyId),
            branchId: Number(branchId),
            menuId: menuId ? Number(menuId) : null,
            menusListId: Number(menusListId),
        },
        context: {
            errorType: "local",
        },
        onError: (error: ApolloError) => {
            if (onError) onError(error);
        },
    });

    const menu = linkAndQrCodeMenuData?.user?.company?.branches?.[0]?.menusList?.[0];
    const qrMenuQrCodeLink = menu?.qrMenuQrCode;
    const qrMenuLink = menu?.qrMenuLink;

    return {
        menu,
        qrMenuQrCodeLink,
        qrMenuLink,
        linkAndQrCodeMenuData,
        linkAndQrCodeMenuLoading,
        linkAndQrCodeMenuRefetch,
    };
};
